// "ziggy" is an alias defined in webpack.mix.js. Eslint can't resolve this alias however.
// eslint-disable-next-line import/no-unresolved
import { route } from "ziggy";
import { getField } from "vuex-map-fields";

const policy = (state) => state.policy;
const renderableTabs = (state) => state.renderableTabs;
const loading = (state) => state.loading;
const policyHeader = (state) => `${state.policy?.name || ""}`;
const isPackage = (state) => state.policy?.is_package;

const policyType = (state, getters) => {
  if (getters.isPackage) {
    return "pakket";
  }
  return "polis";
};

const capitalizedPolicyType = (state, getters) => getters.policyType.charAt(0).toUpperCase()
  + getters.policyType.slice(1);

const editPath = (state) => {
  if (state.policy?.is_package) {
    return route("vue.insurance.package.edit", {
      customer: state.customerId,
      package: state.policy?.id,
      _query: {
        step: state.activeStepId,
        section: state.activeSectionId,
      },
    });
  }
  return state.policy?.parent ? route("vue.insurance.policy.edit", {
    customer: state.customerId,
    package: state.policy?.parent?.id,
    policy: state.policy?.id,
    _query: {
      step: state.activeStepId,
      section: state.activeSectionId,
    },
  }) : route("vue.insurance.policy.edit_single", {
    customer: state.customerId,
    policy: state.policy?.id,
    _query: {
      step: state.activeStepId,
      section: state.activeSectionId,
    },
  });
};
export default {
  policy,
  policyHeader,
  isPackage,
  capitalizedPolicyType,
  policyType,
  renderableTabs,
  loading,
  editPath,
  getField,
};
